import moment from 'moment'
import { Date as DateLanguage, TimeFormats as TimeFormatsLanguage } from '../../../../i18n'
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'

/**
 * Formats a numeric value that specifies a total duration in seconds to "[w]d [x]h [y]m [z]s" format.
 */
export const convertDurationInSecondsToFormattedString = (
    durationInSeconds: number,
    language: CLanguageHandler
): string => {
    language.loadBundle(TimeFormatsLanguage.NAME)

    const formatPatterns: string[] = [
        language.get(TimeFormatsLanguage.Formatpipeddurationdayshrsminssecs),
        language.get(TimeFormatsLanguage.Formatpipeddurationhrsminssecs),
        language.get(TimeFormatsLanguage.Formatpipeddurationminssecs),
        language.get(TimeFormatsLanguage.Formatpipeddurationsecs)
    ]

    // eslint-disable-next-line
    return com.Akixi.Text.CDurationAsSecs(durationInSeconds).toFormattedString(formatPatterns)
}

/**
 * Prepares a date object that is set to the same time as input but time adjusted to the start of minute.
 *
 * @param value Date object to adjust.
 */
export const adjustTimeToStartOfMinute = (value: Date): Date => moment(value).startOf('minute').toDate()

/**
 * Prepares a date object that is set to the same time as input but time adjusted to the end of minute.
 *
 * @param value Date object to adjust.
 */
export const adjustTimeToEndOfMinute = (value: Date): Date => moment(value).endOf('minute').toDate()

/**
 * Parses a text value that specifies a duration in "[w]d [x]h [y]m [z]s" format to total seconds.
 */
export const convertDurationAsFormattedStringToSeconds = (
    durationAsFormatterString: string,
    defaultDurationOnError: number
): number => {
    // eslint-disable-next-line
    const durationInSeconds: number = com.Akixi.Text.ParseFormattedDurationValue(
        durationAsFormatterString,
        defaultDurationOnError
    )
    return durationInSeconds
}

export const convertDateToDurationDateTimeString = (date: Date, language: CLanguageHandler): string => {
    const pattern = `${language.get(DateLanguage.DatePattern)} HH:mm:ss`
    const formattedString = moment(date).format(pattern)
    return formattedString
}

export const convertDateToDurationDateTimeString12HourFormat = (date: Date, language: CLanguageHandler): string => {
    const pattern = `${language.get(DateLanguage.DatePattern)} hh:mm:ss A`
    const formattedString = moment(date).format(pattern)
    return formattedString
}

export const convertDateToDateString = (date: Date, language: CLanguageHandler): string => {
    const pattern = `${language.get(DateLanguage.DatePattern)}`
    const formattedString = moment(date).format(pattern)
    return formattedString
}

export const convertDateToDurationTimeString = (date: Date): string => {
    const pattern = 'HH:mm:ss A' // This pattern covers both en_US and en_GB formats returned from backend.
    const formattedString = moment(date).format(pattern)
    return formattedString
}

export const convertDateToDurationTimeString12HourFormat = (date: Date): string => {
    const pattern = 'hh:mm:ss A'
    const formattedString = moment(date).format(pattern)
    return formattedString
}

export const convertDurationTimeStringToDate = (value: string): Date => {
    const pattern = 'HH:mm:ss A' // This pattern covers both en_US and en_GB formats returned from backend.
    const date = moment(value, pattern).toDate()
    return date
}
